import { create } from 'zustand'

interface IPopupStore {
  isOpenBonusGamePopup: boolean
  isOpenFreeGameConfirmPopup: boolean
  isSelectFreeGame: boolean// FreeGame, BonusGame
  isOpenAny: () => boolean
}

export const usePopupStore = create<IPopupStore>((set, get) => ({
  isOpenBonusGamePopup: false,
  isOpenFreeGameConfirmPopup: false,
  isSelectFreeGame: false,
  isOpenAny: () => {
    const store = get()
    return store.isOpenBonusGamePopup || store.isOpenFreeGameConfirmPopup
  },
}))
